import { EappEnum } from './eAppEnum';

export const emailTypeOptions = new EappEnum([
  { value: '', key: '', text: '' },
  { value: 'Personal Email', key: 'Personal Email', text: 'Personal Email' },
  { value: 'Work Email', key: 'Work Email', text: 'Work Email' },
  { value: 'I Don\'t Know', key: 'I Don\'t Know', text: 'I Don\'t Know' },
]);
